import { ComponentProps } from 'react'

import { AvailableModules } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import UpsellModal from 'modules/upsell/components/UpsellModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

type Props = {
  onClose: () => void
}

const UpsellPromoModal = ({ onClose }: Props) => {
  const hintContent: ComponentProps<typeof UpsellModal.Text>['itemsContent'] = {
    title: i18n.t('payroll_bundle.upsell.product_services_promo.modal.title'),
    description: i18n.t('payroll_bundle.upsell.product_services_promo.modal.description'),
    items: [
      {
        icon: 'user',
        title: i18n.t('payroll_bundle.upsell.product_services_promo.modal.first_item.title'),
        description: i18n.t(
          'payroll_bundle.upsell.product_services_promo.modal.first_item.description'
        ),
      },
      {
        icon: 'events-communications',
        title: i18n.t('payroll_bundle.upsell.product_services_promo.modal.second_item.title'),
        description: i18n.t(
          'payroll_bundle.upsell.product_services_promo.modal.second_item.description'
        ),
      },
      {
        icon: 'edit-file-filled',
        title: i18n.t('payroll_bundle.upsell.product_services_promo.modal.third_item.title'),
        description: i18n.t(
          'payroll_bundle.upsell.product_services_promo.modal.third_item.description'
        ),
      },
      {
        icon: 'contact-us',
        title: i18n.t('payroll_bundle.upsell.product_services_promo.modal.fourth_item.title'),
        description: i18n.t(
          'payroll_bundle.upsell.product_services_promo.modal.fourth_item.description'
        ),
      },
    ],
  }

  return (
    <UpsellModal.Text
      buttonLabel={i18n.t('payroll_bundle.upsell.product_services_promo.modal.button')}
      requestDetail={{
        moduleRequested: AvailableModules.payroll,
        requestReason: ValidReasons.Activation,
        requestSource: 'Payroll policy page',
      }}
      onClose={onClose}
      itemsContent={hintContent}
      bookingMeeting
    />
  )
}

export default UpsellPromoModal
